import React from 'react';

import styles from './Header.module.scss';

type Props = {
  /** Progress fill 0–100 */
  progress?: number;
  /** Hide the back arrow but keep its reserved space (first screen) */
  hideBack?: boolean;
  onBack?: () => void;
};

const BackArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const Header: React.FC<Props> = ({ progress = 0, hideBack = false, onBack }) => (
  <header className={styles.header}>
    <button
      type="button"
      aria-label="Back"
      className={`${styles.back} ${hideBack ? styles.backHidden : ''}`}
      onClick={hideBack ? undefined : onBack}
    >
      <BackArrow />
    </button>
    <div className={styles.track}>
      <div className={styles.fill} style={{ width: `${Math.max(0, Math.min(100, progress))}%` }} />
    </div>
  </header>
);

export default Header;
